import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { DeliveryAccVenture } from '../all-ventures-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<DeliveryAccVenture, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'AccName' }),
		buildColumn(util, 'Id', row => row.accTeamId, { header: 'accTeamId' }),
		buildColumn(util, 'Id', row => row.accVentureId, { header: 'accVentureId' }),
		buildColumn(util, 'Text', row => row.ventureName, { header: 'Venture Name', renderCellClasses: row => row.dropout ? ['grid-cell-strikethrough', 'grid-cell-red-text'] : [] }),
		buildColumn(util, 'Text', row => row.status, { header: 'Status' }),
		buildColumn(util, 'Text', row => row.entrepreneurNames, { header: 'Entrepreneurs' }),
		buildColumn(util, 'Number', row => row.dropout?.dropoutWeek, { header: 'Dropout Week' }),
		buildColumn(util, 'Text', row => row.dropoutReason, { header: 'Dropout Reason' }),
		buildColumn(util, 'Text', row => row.businessType, { header: 'Business Type' }),
		buildColumn(util, 'Text', row => row.industry, { header: 'Industry' }),
		buildColumn(util, 'Text', row => row.offerings, { header: 'Offerings' }),
		buildColumn(util, 'Text', row => row.operatingStatus, { header: 'Operating Status' }),
	];


	return columns;

}